<template>
  <div
    style="margin-left: 100px; width: 1000px; height: 1000px; overflow: hidden"
  >
    <VueFlow
      ref="vueFlow"
      :nodes="[]"
      :edges="[]"
      :default-viewport="{ zoom: 1 }"
      :pan-on-scroll="true"
      :pan-on-drag="true"
      v-slot="{ viewport }"
    >
      <div>hello world</div>
      <pre>{{ viewport }}</pre>
      <div v-if="viewport">
        <p>Viewport X: {{ viewport.x }}</p>
        <p>Viewport Y: {{ viewport.y }}</p>
        <p>Viewport Zoom: {{ viewport.zoom }}</p>
      </div>
      <div v-else>
        <p>Viewport is undefined</p>
      </div>
      <CustomBackground />
    </VueFlow>
  </div>
</template>

<script>
import { VueFlow } from "@vue-flow/core";
// import { Background } from "@vue-flow/background";
import CustomBackground from "../../../components/utilities/CustomBackground.vue";

export default {
  components: { VueFlow, CustomBackground },
  mounted() {
    console.log(this.$refs.vueFlow); // Log the VueFlow instance
  },
};
</script>
